// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

const scrollToHashTarget = () => {
  if (!window.location.hash) return

  const target = document.getElementById(window.location.hash.slice(1))
  if (!target) return

  requestAnimationFrame(() => target.scrollIntoView({ block: "start" }))
}

document.addEventListener("turbo:load", scrollToHashTarget)
window.addEventListener("hashchange", scrollToHashTarget)
scrollToHashTarget()
